import { ApplicationRoleCode as ApplicationRoleCodeEnum } from '@kcftech/prometheus-client';
import { SelectOption } from 'components/forms/Select';
import { DropdownInlineEditor } from 'components/inline_edit/DropdownInlineEditor';
import { usePermissions } from 'contexts/PermissionsContext';
import { useValidUserRoleOptions } from 'custom_hooks/data_hooks/user/useValidUserRoleOptions';
import { applicationRoleToName } from 'pages/Settings/Users/shared';
import { UsersTableCellProps } from 'pages/Settings/Users/UsersTable';
import { updateUser } from 'utils/user';

export function UserApplicationRoleCodeCell({ rowData, onChange }: UsersTableCellProps) {
    const userRoleOptions = useValidUserRoleOptions();
    const { ApplicationRoleCode } = rowData;
    const selectedOption = {
        title: applicationRoleToName[ApplicationRoleCode],
        value: ApplicationRoleCode,
    };

    const { canEditUserProperties } = usePermissions();

    const onSave = async (newRole: SelectOption | undefined) => {
        if (!newRole) {
            throw new Error('Attempted to save role without a role');
        }
        try {
            await updateUser(rowData.Id, {
                ApplicationRoleCode: newRole.value as ApplicationRoleCodeEnum,
            });
            onChange();
        } catch {
            return 'Unable to save application role code';
        }
        return undefined;
    };

    return (
        <DropdownInlineEditor
            options={userRoleOptions}
            dropdownConfig={{
                renderLabel: ({ value }) => value?.title,
                dataKey: (item) => item.value,
                renderItem: ({ item }) => item.title,
                popup: { width: '16rem' },
            }}
            value={selectedOption}
            renderValue={(value) => value?.title}
            onConfirm={onSave}
            isDisabled={!canEditUserProperties}
        />
    );
}
